import { pageDefinition } from 'site-modules/shared/pages/page';
import { getPageOptions } from 'site-modules/editorial/pages/top-rated/top-rated-article-definition';
import { getTopRatedArticleContentPath } from 'site-modules/shared/utils/top-rated/content-path';
import { TopRatedArticle } from './top-rated-article';

const pages = new Map();
export default ({ type, year, chunkName }) => {
  const key = getTopRatedArticleContentPath(type, year);
  let page = pages.get(key);
  if (!page) {
    page = pageDefinition(getPageOptions({ type, year, pageTemplate: TopRatedArticle, chunkName }));
    pages.set(key, page);
  }
  return page;
};
